import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService } from '../../services/events/events.service';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { CacheService } from '../../services/Cache/cache.service';
import { OrderService } from '../../services/Order/order.service';
import { PedidoObject } from '../../models/pedido.class';

@Component({
  selector: 'app-receipt-card',
  templateUrl: './receipt-card.component.html',
  styleUrls: ['../../../../assets/styles/global/_card.css', './receipt-card.component.css']
})
export class ReceiptCardComponent implements OnInit, AfterViewInit{
  step = false;
  company!: Company;
  selectedOption: { checked: boolean, value: number } = { checked: false, value: 0};
  get pedido(): PedidoObject {
    return this.orderService.pedidoAtual;
  }
  @Output() optionSelected: EventEmitter<{ checked: boolean, value: number }> = new EventEmitter<{ checked: boolean, value: number }>();

  constructor(private eventsService: EventsService, private connection: ConnectionService, private cacheService: CacheService, private orderService: OrderService){}

  ngOnInit(): void {
    console.log(this.pedido)
      if(this.selectedOption.checked == false)
      {
        this.step = true;
      }

      if(this.orderService.pedidoAtual.orderType != 0){
        let type = this.orderService.pedidoAtual.orderType;
        if (this.isDeliveryDisabled() && type === 5) {
           type = 3;
        }
        const data = {checked: true, value: type}
        this.onCheckboxChange(data)
      }

      // this.eventsService.eventTypeReceipt$.subscribe((newValue) =>{
      //   if(newValue != 0){
      //     const data = {checked: true, value: newValue}
      //     this.onCheckboxChange(data)
      //   }
      // });

      // if(this.eventsService.eventTypeReceipt != 0){
      //   const data = {checked: true, value: this.eventsService.eventTypeReceipt}
      //   this.onCheckboxChange(data)
      // }
      this.connection.company$.subscribe((newCompany) =>{
        this.company = newCompany
        if(this.company.configs.receipt == 1)
        {
          const data = {checked: true, value: this.isDeliveryDisabled() ? 3 : 5}
          this.onCheckboxChange(data)
        }
        else if(this.company.configs.receipt == 2)
        {
          const data = {checked: true, value: 3}
          this.onCheckboxChange(data)
        }
      })
  }
  ngAfterViewInit(): void {
    // if(this.company.configs.receipt == 1)
    // {
    //   const data = {checked: true, value: 5}
    //   this.onCheckboxChange(data)
    // }
    // else if(this.company.configs.receipt == 2)
    // {
    //   const data = {checked: true, value: 3}
    //   this.onCheckboxChange(data)
    // }
  }

  ngOnDestroy(): void {
    // this.eventsService.eventTypeReceipt = 0
    // this.selectedOption = {checked: false, value: 0}
    // this.optionSelected.emit({ checked: false, value: 0 });
  }

  onCheckboxChange(data: { checked: boolean, value: any }) {
    this.selectedOption = { checked: data.checked, value: data.value};
    this.optionSelected.emit({ checked: data.checked, value: data.value});
  }

  changeButton(){
    this.selectedOption.checked = false;
    this.selectedOption.value = 0
    this.optionSelected.emit({ checked: false, value: 0 });
    this.eventsService.eventTypeReceipt = 0
  }

  isDeliveryDisabled(): boolean {
    if (this.pedido && this.pedido.products) {
      return this.pedido.products.some(product => product.deliveryOn === 3);
    }
    return false;
  }
}
